export default __webpack_public_path__ + "static/media/no-races.cc842d7e.png";